/**
 * marketPulsePageData — PULSEPERF-002 (ui-safe).
 *
 * The Market Pulse page requests the slim strategy-context variant
 * (`?lite=true`, drops the 12k-symbol tradable_universe, ~2.7MB) and reads the
 * backend-provided `tradable_universe_count`.
 *
 * NOTE: the movers `?view=board` slimming was intentionally NOT adopted for this
 * page — the board projection's `combined_mover_ticker` structurally excludes
 * forex, which would drop the Top Tradable Movers "Forex" section. The page
 * therefore keeps the full movers payload (made non-blocking by backend FIX 1).
 */

export const STRATEGY_LITE_PATH = "/market-pulse/strategy-context?lite=true";

/**
 * Tradable-instrument count for LeadSummary / TradableCard. Under `?lite=true`
 * the universe array is empty, so prefer the backend-provided count; fall back
 * to counting the array for a full payload. Returns a non-negative integer.
 */
export function strategyTradableCount(
  strategy: Record<string, unknown> | null | undefined,
  filterTradable: (items: Record<string, unknown>[]) => Record<string, unknown>[],
): number {
  if (!strategy) return 0;
  const universe = strategy["tradable_universe"];
  if (Array.isArray(universe) && universe.length > 0) {
    return filterTradable(universe as Record<string, unknown>[]).length;
  }
  const count = strategy["tradable_universe_count"];
  const n = typeof count === "number" ? count : Number(count);
  return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
}
